import React from "react";

const BrandDashboardIcon = ({
  width = 40,
  height = 40,
  fill = "#4355B9",
  className,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M4 11.2V5.6C4 4.71634 4.71634 4 5.6 4H11.2C12.0837 4 12.8 4.71634 12.8 5.6V11.2C12.8 12.0837 12.0837 12.8 11.2 12.8H5.6C4.71634 12.8 4 12.0837 4 11.2Z"
        fill={fill}
      />
      <path
        d="M4 18.4V16.8C4 15.9163 4.71634 15.2 5.6 15.2H11.2C12.0837 15.2 12.8 15.9163 12.8 16.8V18.4C12.8 19.2837 12.0837 20 11.2 20H5.6C4.71634 20 4 19.2837 4 18.4Z"
        fill={fill}
      />
      <path
        d="M15.2 18.4V12.8C15.2 11.9163 15.9163 11.2 16.8 11.2H18.4C19.2837 11.2 20 11.9163 20 12.8V18.4C20 19.2837 19.2837 20 18.4 20H16.8C15.9163 20 15.2 19.2837 15.2 18.4Z"
        fill={fill}
      />
      <path
        d="M15.2 7.2V5.6C15.2 4.71634 15.9163 4 16.8 4H18.4C19.2837 4 20 4.71634 20 5.6V7.2C20 8.08366 19.2837 8.8 18.4 8.8H16.8C15.9163 8.8 15.2 8.08366 15.2 7.2Z"
        fill={fill}
      />
    </svg>
  );
};

export default BrandDashboardIcon;

